import { Card, CardContent } from "@getgreenline/blaze-ui";
import { CalendarDays } from "lucide-react";

type DailyDistributionCardProps = {
  dailyBudget: number;
  formattedBudget: string;
  campaignDays: number | null;
};

export function DailyDistributionCard({
  dailyBudget,
  formattedBudget,
  campaignDays,
}: DailyDistributionCardProps) {
  return (
    <Card className="tw:mt-5 tw:border-border tw:bg-muted/40 tw:px-4 tw:py-3 tw:shadow-none">
      <CardContent className="tw:flex tw:items-center tw:gap-4 tw:p-0">
        <div className="tw:flex tw:h-9 tw:w-9 tw:items-center tw:justify-center tw:rounded-xl tw:bg-sky-100 tw:text-sky-700">
          <CalendarDays className="tw:h-4 tw:w-4" />
        </div>
        <div>
          <p className="tw:text-sm tw:text-muted-foreground/40">
            Daily distribution
          </p>
          <p className="tw:text-lg tw:font-semibold tw:text-foreground">
            {dailyBudget > 0 ? `$${dailyBudget} / day` : "$0 / day"}
          </p>
          <p className="tw:text-sm tw:text-muted-foreground/40">
            {formattedBudget}
            {campaignDays
              ? ` ÷ ${campaignDays} days`
              : " ÷ campaign duration"}{" "}
            distributed automatically across your placements
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
